export const IconPlus = ({ className }: { className: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.6667 0V10.6667H0V13.3333H10.6667V24H13.3333V13.3333H24V10.6667H13.3333V0H10.6667Z"
      fill="currentColor"
    />
  </svg>
);
